export const chosenFirst = (items, selected)=>{
    const chosen = new Set(selected);
    const inSelection = items.filter((item)=>chosen.has(item.value));
    const rest = items.filter((item)=>!chosen.has(item.value));
    return [
        ...inSelection,
        ...rest
    ];
};
export const valueLabelFor = (items, selected, texts)=>{
    var _ref;
    var _items_find;
    if (selected.length === 0) return texts.all;
    if (selected.length === 1) return (_ref = (_items_find = items.find((item)=>item.value === selected[0])) === null || _items_find === void 0 ? void 0 : _items_find.label) !== null && _ref !== void 0 ? _ref : selected[0];
    return texts.count(selected.length);
};
